/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Tasks_Protocol_Sent_CreditsInputs */

const cs_tasks_protocol_sent_credits = /** @type {(inputs: Tasks_Protocol_Sent_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odesláno k podpisu (−${i?.credits} kreditů)`)
};

const en_tasks_protocol_sent_credits = /** @type {(inputs: Tasks_Protocol_Sent_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sent for signing (−${i?.credits} credits)`)
};

/**
* | output |
* | --- |
* | "Sent for signing (−{credits} credits)" |
*
* @param {Tasks_Protocol_Sent_CreditsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_sent_credits = /** @type {((inputs: Tasks_Protocol_Sent_CreditsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Sent_CreditsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_sent_credits(inputs)
	return cs_tasks_protocol_sent_credits(inputs)
});